import React from 'react';
import { TableCell, Box, Typography } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { SortDirection } from '../../hooks/useTableSort';

interface SortableTableHeaderProps {
  field: string;
  label: string;
  sortDirection: SortDirection | null;
  sortIndex: number;
  onSort: (field: string, ctrlKey: boolean) => void;
  align?: 'left' | 'center' | 'right';
  sx?: any;
}

const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  field,
  label,
  sortDirection,
  sortIndex,
  onSort,
  align = 'left',
  sx = {}
}) => {
  const handleClick = (event: React.MouseEvent) => {
    onSort(field, event.ctrlKey);
  };

  return (
    <TableCell
      align={align}
      sx={{
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        },
        ...sx
      }}
      onClick={handleClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="inherit" sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
          {label}
        </Typography>
        
        {/* Sort indicators */}
        <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 20 }}>
          {sortDirection && (
            <>
              {sortDirection === 'asc' ? (
                <ArrowUpward sx={{ fontSize: 16, color: 'primary.main' }} />
              ) : (
                <ArrowDownward sx={{ fontSize: 16, color: 'primary.main' }} />
              )}
              {sortIndex > 0 && (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 10,
                    color: 'primary.main',
                    fontWeight: 'bold',
                    lineHeight: 1,
                    textAlign: 'center',
                    minHeight: 12
                  }}
                >
                  {sortIndex}
                </Typography>
              )}
            </>
          )}
          {!sortDirection && (
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              opacity: 0.3,
              '&:hover': { opacity: 0.6 }
            }}>
              <ArrowUpward sx={{ fontSize: 12, lineHeight: 0.5 }} />
              <ArrowDownward sx={{ fontSize: 12, lineHeight: 0.5, mt: -0.5 }} />
            </Box>
          )}
        </Box>
      </Box>
    </TableCell>
  );
};

export default SortableTableHeader;
